// extracted by mini-css-extract-plugin
export default {"macro-btn":"SelectorCategory_macro-btn__kJDZz","macro-btn-sel":"SelectorCategory_macro-btn-sel__R+2RH"};